// Builds the one URL that opens a specific question inside a specific checklist
// on the job page. Kept in one place because the tab segment is an encoding, not
// a name: TabSwitcher reads `<tabsId>_<tabName>` out of the `tab` param, so the
// job page's Forms tab is addressed as `jp_Forms` and nothing about that is
// guessable from the label.

const JOB_TABS_ID = "jp";
const FORMS_TAB_NAME = "Forms";

// The query param that names an open submission. Shared with every surface that
// opens one — the job page's Forms tab and the customer record's — so the four
// places that read or write it cannot drift.
export const SUBMISSION_QUERY_KEY = "custom_form_submission_id";

// Its companion on surfaces that are not already scoped to a job. The detail
// endpoint is job-nested, so the submission id alone cannot be resolved: the job
// page gets it from the route, and the customer record has to carry it in the URL
// or its deep link is write-only.
export const SUBMISSION_JOB_QUERY_KEY = "custom_form_job_id";

// Omit questionId to address the checklist itself rather than one question.
// Null rather than a URL when the job is unknown — `/jobs/undefined` is a dead
// link nothing else blocks.
export function jobFormQuestionUrl(
  jobId: number | string | null | undefined,
  submissionId: number,
  questionId?: number
): string | null {
  if (!jobId) return null;

  const params = new URLSearchParams({
    tab: `${JOB_TABS_ID}_${FORMS_TAB_NAME}`,
    [SUBMISSION_QUERY_KEY]: String(submissionId)
  });
  if (questionId) params.set("custom_form_question_id", String(questionId));
  return `/jobs/${jobId}?${params.toString()}`;
}
